import { Box } from "@material-ui/core";
import React from "react";
import { ContentCurve, LogoImage } from "../Page/Page";
import {FooterContext, FooterWrapper} from "./FooterStyles";
import instyleLogo from '../../images/instyle-logo.svg';

function Footer() {

    return (
        <FooterWrapper>
            <FooterContext>
                <a href="https://instylesolar.com">
                    <LogoImage src={instyleLogo} alt="Instyle Solar" />
                </a>
                <p>
                    &copy; {new Date().getFullYear()} &nbsp;
                    <a href="https://instylesolar.com/">Instyle Solar</a>. All rights reserved. <br/>
                    <a href="https://instylesolar.com/terms-conditions">Terms & conditions</a> &nbsp; &nbsp; &nbsp; <a href="https://instylesolar.com/privacy">Privacy Policy</a>
                </p>
            </FooterContext>
        </FooterWrapper>
    )

}

export default Footer;